<template>
    <NuxtLink v-bind="attrs"><slot></slot></NuxtLink>
</template>

<script lang="ts" setup>
import { utility } from "various-ui";
import type { NavigateToRoute } from "@/utils/router/src/types";

//* Props获取, 保持与NuxtLink统一
const define = defineProps({
    to: { type: [String, Object] as PropType<string | NavigateToRoute>, required: true },
    rel: { type: String },
    noRel: { type: Boolean, default: true },
    custom: { type: Boolean, default: undefined },
    target: { type: String as PropType<"_blank" | "_parent" | "_self" | "_top">, default: "_blank" },
    replace: { type: Boolean, default: undefined },
    language: { type: String, default: undefined },
    external: { type: Boolean, default: undefined },
    prefetch: { type: Boolean, default: undefined },
    activeClass: { type: String },
    exactActiveClass: { type: String },
    ariaCurrentValue: { type: String },
});

//* attr属性对象
const attrs = computed(() => {
    const { href, options } = routerResolve(define.to, define.language);
    return {
        ...utility.objectPick(define, (data) => data != undefined, ["to", "external"]),
        ...{ to: href, prefetch: define.target == "_blank" ? false : define.prefetch, external: !!define.external || !!options?.external },
    };
});
</script>
